import type { GraphViewId, GraphViewPreviewable } from '@ipfabric/utils';
import { fetchViews } from 'components/Graph/commands/fetchViews';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface DeleteViewsCommand {
  views: GraphViewPreviewable[];
}

export const deleteViews: GraphCommandFactory<DeleteViewsCommand> =
  (cmdContext, dispatch) => async (command: DeleteViewsCommand) => {
    await cmdContext.api.request<void, GraphViewId[]>({
      url: '/graphs/views',
      method: 'DELETE',
      data: command.views.map((view) => view.id),
    });

    cmdContext.updateState((draft) => {
      if (
        command.views.find(
          (view) => view.id === draft.loadViewDialog.loadedView?.id,
        )
      ) {
        draft.loadViewDialog.loadedView = null;
      }
    });

    await dispatch(fetchViews);
  };
